import React, {useEffect, useState} from 'react';
import $ from "jquery";
import ContentTop from "../../../../components/ContentTop";
import {CloseOutlined, SearchOutlined, BlockOutlined} from "@ant-design/icons";
import Card from "../../../../components/Card";
import Chart3 from "../../../../components/Charts/Chart3";
import {NavLink, Route, Routes, useParams} from "react-router-dom";
import Soatlik from "./Soatlik";
import locationred from "../../../../icons/locationred2.png";
import locationgray from "../../../../icons/locationgray2.png";
import editgray from "../../../../icons/editgray.png";
import Kunlik from "./Kunlik";
import axios from "axios";
import Map from "../../../../components/map/Googlemap/Map";
import Dekadalik from "./Dekadalik";
import Oylik from "./Oylik";
import Yillik from "./Yillik";
import {user_data} from "../../../../components/functions/usr";

function AqlliSuv(props) {
    const d_ids = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,164,150,151,152,153,154,155,156,157,158,159,160,161,162,163,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,165]
    const user = user_data()
    const region = user.region_id
    const district = d_ids[user.district_id]
    const [isfilter, setIsfilter] = useState(null)
    const [locations,setLocations] = useState([])
    const [filterStation, setFilterStation] = useState('')
    const [screenMode,setScreenMode] = useState(false)
    const link = useParams()
    useEffect(()=>{
        switch (link['*']){
                case 'kunlik': setMenu(2); break;
                case 'dekada': setMenu(3); break;
                case 'oylik': setMenu(4); break;
                case 'yillik': setMenu(5); break;
            default: setMenu(1)
        }
    },[])

    const [data, setData] = useState([])
    const [activeList, setActiveList] = useState('')
    const [selectedRowKeys, setSelectedRowKeys] = useState('');

    const [labels,setLabels] = useState([])
    const close = () => {
        if(selectedRowKeys !== '') {
            $('tr.tr'+selectedRowKeys+' input')[0].checked = false
            $('tr.tr'+selectedRowKeys).removeClass('active')
        }
        setSelectedRowKeys('')
    }
    const setSearchHandler = (text) => {
        let actives = 0;
        $('ul.stations-list li').each(function(){
            if ($(this).children('span')[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
                $(this)[0].style.display = "";
                actives++;
            } else {
                $(this)[0].style.display = "none";
            }
        })
        setActiveList(actives)
    }
    const [menu, setMenu] = useState(1)
    return (
        <div>
            <ContentTop>
                <ul className="content-top-left">
                    <li>Aqlli suv</li>
                </ul>
                <ul className="content-top-right menu">
                    <li>
                        <button className={menu==1?"active":""} onClick={()=>{setMenu(1);close()}}>
                            <NavLink to="/aqllisuv">Soatlik</NavLink>
                        </button>
                    </li>
                    <li>
                        <button className={menu==2?"active":""} onClick={()=>{setMenu(2);close()}}>
                            <NavLink to="/aqllisuv/kunlik">Kunlik</NavLink>
                        </button>
                    </li>
                    <li>
                        <button className={menu==3?"active":""} onClick={()=>{setMenu(3);close()}}>
                            <NavLink to="/aqllisuv/dekada">10 kunlik</NavLink>
                        </button>
                    </li>
                    <li>
                        <button className={menu==4?"active":""} onClick={()=>{setMenu(4);close()}}>
                            <NavLink to="/aqllisuv/oylik">Oylik</NavLink>
                        </button>
                    </li>
                    <li>
                        <button className={menu==5?"active":""} onClick={()=>{setMenu(5);close()}}>
                            <NavLink to="/aqllisuv/yillik">Yillik</NavLink>
                        </button>
                    </li>
                </ul>
            </ContentTop>
            <div className="row">
                <div className="col-md-9">
                    <Routes>
                        <Route path="/" element={
                            <Soatlik setLocations={setLocations} setLabels={setLabels} region={region} district={district} setData={setData} data={data} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }/>
                        <Route path="/kunlik" element={
                            <Kunlik setLocations={setLocations} setLabels={setLabels} region={region} district={district} setData={setData} data={data} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }/>
                        <Route path="/dekada" element={
                            <Dekadalik setLocations={setLocations} setLabels={setLabels} region={region} district={district} setData={setData} data={data} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }/>
                        <Route path="/oylik" element={
                            <Oylik setLocations={setLocations} setLabels={setLabels} region={region} district={district} setData={setData} data={data} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }/>
                        <Route path="/yillik" element={
                            <Yillik setLocations={setLocations} setLabels={setLabels} region={region} district={district} setData={setData} data={data} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys}/>
                        }/>
                    </Routes>
                    {
                        selectedRowKeys.length === 0 ? null :
                            <div className="data-content mt-3 mainpage" style={{position:"relative"}}>
                                <CloseOutlined
                                    style={{
                                        position:"absolute",
                                        top:0,
                                        right:10,
                                        zIndex:9,
                                        fontSize:'20px',
                                        cursor:"pointer"
                                    }}
                                    onClick={close}
                                />
                                <Card additionalClass={screenMode?'full-screen':'simple-screen'}>
                                    <div className="screenMode">
                                        <BlockOutlined onClick={()=>setScreenMode(!screenMode)}/>
                                    </div>
                                    <div className="mapBlock">
                                        <Map stations={locations} center={{lat:parseFloat(data[selectedRowKeys].lat), lng:parseFloat(data[selectedRowKeys].lan)}} isfilter={isfilter}/>
                                    </div>
                                </Card>

                                <Chart3
                                    datas={data[selectedRowKeys]['data']}
                                    labels={labels}
                                />
                            </div>
                    }
                </div>
                <div className="col-md-3">
                    <div className="card-smartwater mt-3">
                        <div className="smartwater-search">
                            <input id="bbr" type="input" placeholder="Kuzatuv stansiyasi" value={filterStation} onChange={e=>{
                                setFilterStation(e.target.value)
                                setSearchHandler(e.target.value)
                            }}/>
                            <span>soni: {activeList===''?data.length:activeList}/{data.length} ta</span>
                            <label htmlFor="bbr"><SearchOutlined style={{ color: '#6E8BF5' }} /></label>
                        </div>
                        <div className="row">
                            <div className="details-box-left-change _details-box-left-change">
                                <ul className="stations-list">
                                    {
                                        data.length?
                                            data.map((d,i)=>{
                                                return <li key={i} className={d.location?"active-location":""} onClick={()=>setSelectedRowKeys(i)}>
                                                    <span>
                                                        {d.location?<img src={locationred} alt="404"/>:<img src={locationgray} alt="404"/>}&nbsp;&nbsp;
                                                        <img src={editgray} alt="404"/>&nbsp;&nbsp;
                                                        {d.name}
                                                    </span>
                                                    <span className="text-danger">{d.volume}</span>
                                                </li>
                                            })
                                            :null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AqlliSuv;